import { configure } from 'mobx';

/** MobX 6+ no longer supports `reactionScheduler`; defaults work with React 18/19. */
export const configureMobX = () => {
    configure({
        enforceActions: 'never',
    });
};
